/**
 * Creates an array of arrays, grouping consecutive elements by a key function
 */
export const groupConsecutive = <T, K>(array: T[], keyFn: (item: T) => K): T[][] => {
  if (array.length === 0) return []

  const result: T[][] = []
  let currentGroup: T[] = [array[0] as T]
  let currentKey = keyFn(array[0] as T)

  for (let i = 1; i < array.length; i++) {
    const key = keyFn(array[i] as T)
    if (key === currentKey) {
      currentGroup.push(array[i] as T)
    } else {
      result.push(currentGroup)
      currentGroup = [array[i] as T]
      currentKey = key
    }
  }

  result.push(currentGroup)
  return result
}
